import * as React from 'react';
import Home from '@ui/scenes/Home';

const HomePage: React.FunctionComponent<{}> = () => (
  <div>
    <Home />
  </div>
);

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/Home/Home.tsx